import { useMemo } from 'react'
import styled from 'styled-components'
import { AppModal } from '../../../../../generic/ui/Modal'
import { GridTable, TableSummary, TableToolbar } from '../../../../../generic/grid-table'
import ReportFilterForm from './Components/ReportFilterForm'
import { useQ4Report } from './hooks/useQ4Report'
import { buildReportColumns } from '../shared/configs/report.columns'
import { buildQ4SummaryItems } from './configs/q4.summary'
import { ReportRow } from '../shared/types/row'

const MainQ4 = () => {
  const {
    metaData,
    rows,
    totalCount,
    hasData,
    isLoading,
    summary,
    searchQuery,
    handleSearch,
    isFilterOpen,
    toggleFilter,
    filterFormProps,
    handleExport,
  } = useQ4Report()

  const columns = useMemo(() => (metaData ? buildReportColumns(metaData) : []), [metaData])
  const summaryItems = useMemo(() => buildQ4SummaryItems(summary), [summary])

  return (
    <TableSection>
      {isFilterOpen && (
        <AppModal
          title='שאילתת תעודות משלוח'
          Children={ReportFilterForm}
          childrenProps={filterFormProps}
          controlFunc={toggleFilter}
          size='sm'
        />
      )}
      <GridTable<ReportRow>
        title='סיכום תעודות משלוח Q4'
        count={totalCount}
        columns={columns}
        rows={rows}
        getRowId={(row) => row.rowId}
        isLoading={isLoading}
        emptyTitle='בחר דוח ותאריכים'
        summary={hasData ? <TableSummary items={summaryItems} /> : undefined}
        collapsibleSummary
        toolbarActions={
          <TableToolbar
            searchValue={searchQuery}
            onSearchChange={handleSearch}
            searchPlaceholder='חיפוש…'
            onExport={handleExport}
            onFilter={toggleFilter}
          />
        }
      />
    </TableSection>
  )
}

export default MainQ4

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.8em;
  width: 100%;
  height: 100%;
  padding: 0.5em;
  overflow: hidden;
`
